<template>
    <button class="simple-button">
        <Icon v-if="icon" :icon-name="icon"/>
        {{ text }}
    </button>
</template>

<script>
    import Icon from "@/scripts/common/Icon.vue";

    export default {
        name:'SimpleAiButton',
        components: {
            Icon
        },
        props: ['text', 'icon'],

    }
</script>

<style scoped lang="scss">
    .simple-button {
        display: inline-flex;
        padding: 6px 12px 6px 6px;
        align-items: center;
        gap: 6px;
        border-radius: 4px;
        background-color: var(--asphalt90);
        backdrop-filter: blur(2px);

        outline: none;
        border: none;
        font: var(--editor-ui-b2-regular);
        color: var(--asphalt30);

        &.active {
            outline: none;
        }

        &.disabled {
            background-color: var(--asphalt90);
            color: var(--asphalt60);
            cursor: default;
        }

        &:hover {
            background-color: var(--asphalt80);
            cursor: pointer;
        }

        svg {
            width: 20px;
            height: 20px;
            aspect-ratio: 1/1;
        }
    }
</style>